import * as NoMatch_en from './NoMatch.en.js';
import * as NoMatch_es from './NoMatch.es.js';

const NoMatchTuple = [
  { type: 'NoMatch', language: 'en', object: NoMatch_en.default },
  { type: 'NoMatch', language: 'es', object: NoMatch_es.default },
];

export default NoMatchTuple;
